import React from 'react';
import { SOCIAL_PLATFORMS } from './constants';

interface Props {
  selectedPlatform: string | null;
  onSelect: (platform: string | null) => void;
}

export const SocialPlatformSelector: React.FC<Props> = ({ selectedPlatform, onSelect }) => {
  return (
    <>
      <label className="block text-gray-600 font-semibold mb-2">
        Select Social Media Platform:
      </label>
      <div className="flex flex-wrap">
        {SOCIAL_PLATFORMS.map((platform) => (
          <div
            key={platform.value}
            onClick={() => onSelect(platform.value === selectedPlatform ? null : platform.value)}
            className={`
                            w-40 h-40 flex flex-col items-center justify-center border rounded-lg 
                            cursor-pointer m-2 transition duration-300 relative shadow-lg
                            ${
                              selectedPlatform === platform.value
                                ? 'bg-green-600 text-white transform scale-105'
                                : 'bg-white text-gray-700 hover:shadow-xl'
                            }
                        `}
          >
            <img
              src={platform.icon}
              alt={`${platform.name} icon`}
              className="w-12 h-12 object-contain"
            />
            <span
              className={`mt-2 font-medium ${selectedPlatform === platform.value ? 'text-gray-300' : ''}`}
            >
              {platform.name}
            </span>
          </div>
        ))}
      </div>
    </>
  );
};
